var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "531px",
    height: "88px",
    viewBox: "0 0 531 88",
    style: {
      enableBackground: "new 0 0 531 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,64.4l7-4c2,4.7,8.8,13.1,20.5,13.1c10.2,0,18.1-5.5,18.1-14.3c0-6.9-4.6-12-14.1-13.9l-7.6-1.5 c-10.6-2.1-19.2-9.1-19.2-21c0-9.8,7.9-20.2,23.4-20.2c10.6,0,19.1,5.9,22.6,14.4l-6.8,4.1c-2-6.2-9-10.9-15.8-10.9 c-9.8,0-15.1,6.1-15.1,12.6c0,7.2,5.1,11.5,12.4,12.9l7.8,1.5c14.5,2.8,20.9,12.3,20.9,21.9c0,10.4-9,22.1-26.5,22.1 C13.8,81.2,5,71,2,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.8,80.1V3.7H142v7.6h-39V37h35.8v7.4H103v28.1h39v7.6H94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.7,71.8l12.1,13.6h-10.2l-8.2-9.3c-5.7,3.2-12.3,5-19.4,5c-22.1,0-39.2-17.5-39.2-39.3 c0-21.8,17.1-39.3,39.2-39.3s39.3,17.5,39.3,39.3C255.4,53.9,250.1,64.6,241.7,71.8z M229.9,69.9l-16.6-18.8h9.9l13,14.6 c6.4-5.8,10.4-14.3,10.4-23.8c0-17.4-13-31.2-30.6-31.2c-17.6,0-30.6,13.9-30.6,31.2c0,17.4,12.9,31.2,30.6,31.2 C221.2,73.1,225.9,71.9,229.9,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.6,51.6V3.7h8.2v47.9c0,12.3,7.9,21.5,20.6,21.5c12.9,0,20.9-9.2,20.9-21.5V3.7h8.2v47.9 c0,16.9-11.8,29.6-29,29.6C305.3,81.2,293.6,68.5,293.6,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,80.1V3.7h47.2v7.6h-39V37h35.8v7.4h-35.8v28.1h39v7.6H395.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.7,80.1V3.7h8.2v68.6h35.7v7.9H483.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.27d686b420de0fd8930e4078f8d4383e.svg";
export { ForwardRef as ReactComponent };